import styles from './AuthMessage.module.css';

export default function AuthMessage({ tone = 'error', children }) {
  if (!children) return null;
  return <div className={`${styles.banner} ${tone === 'success' ? styles.success : styles.error}`}>{children}</div>;
}
